import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { HttpError, HttpService } from 'src/toolkit';

import { TAccountClientContact, TAccountClientContactPayloadUpdate, TAccountClientContactResponse, adaptAccountClientContactFromResponse, adaptAccountClientContactToRequest } from '../../types';
import { useAppSelector } from '../../hooks';
import { BACKEND_ACCOUNT_CLIENT } from '../../backend-paths';


export const accountClientContactUpdateApi = createAsyncThunk(
	`PUT/${BACKEND_ACCOUNT_CLIENT}/:client_id/contacts/:id`,
	(payload: TAccountClientContactPayloadUpdate, thunkApi) => {
		const { id, clientId, data } = payload;
		const path = `${BACKEND_ACCOUNT_CLIENT}/${clientId}/contacts/${id}`;
		const dataRequest = adaptAccountClientContactToRequest(data);

		return HttpService.put<TAccountClientContactResponse>(path, dataRequest).then(result => {
			return adaptAccountClientContactFromResponse(result.data);
		}).catch((error: HttpError) => {
			return thunkApi.rejectWithValue({ ...error });
		});
	},
);

type TInitialState = {
	item: TAccountClientContact | undefined,
	isLoading: boolean,
	error?: HttpError,
};

const initialState: TInitialState = {
	item: undefined,
	isLoading: false,
	error: undefined,
};

export const accountClientContactUpdateSlice = createSlice({
	name: 'accountClientContactUpdateSlice',
	initialState,
	reducers: {
		clearAccountClientContactUpdate(state) {
			return { ...initialState };
		},
	},

	extraReducers: {
		[accountClientContactUpdateApi.pending.type]: (state) => {
			state.isLoading = true;
			state.error = undefined;
		},

		[accountClientContactUpdateApi.fulfilled.type]: (state, action: PayloadAction<TAccountClientContact>) => {
			state.isLoading = false;
			state.item = action.payload;
		},

		[accountClientContactUpdateApi.rejected.type]: (state, action: PayloadAction<HttpError>) => {
			state.isLoading = false;
			state.error = action.payload;
		},
	},
});

export const useAccountClientContactUpdateSelector = () => useAppSelector(state => state[accountClientContactUpdateSlice.name]);

export const { clearAccountClientContactUpdate } = accountClientContactUpdateSlice.actions;
